module.exports = __webpack_public_path__ + "img/module-telehealth.e47f712f.svg";